export default __webpack_public_path__ + "static/media/waiter.ca83a588.svg";